window.addEventListener("load", () => {
  /* Nav colletion separation */
  const LinksForHeader = document.querySelectorAll(".hc-header-item-nav-normal .megamenu__link-label[data-linklabel]");
  const LinksForHeaderSticky = document.querySelectorAll(".hc-header-item-nav-nd .megamenu__link-label[data-linklabel]");

  LinksForHeader.forEach(item => {
    hcLookbookHeaderSolution(item);
  });

  LinksForHeaderSticky.forEach(item => {
    hcLookbookHeaderSolution(item);
  });

  function hcLookbookHeaderSolution(item) {
    let counterOfSeparation = 0;
    let counterOfSeparationNew = 0;
    const parentText = item.textContent.trim();
    const parentDataLabel = item.getAttribute("data-linklabel");
    if (parentText.toLowerCase() === "collections" && parentDataLabel.toLowerCase() === "collections") {
      const childLinks = Array.from(item.closest(".megamenu__col").querySelectorAll("a:not(.megamenu__col-title a, .site-nav__view-archive-link)"));
      childLinks.forEach((link, index, links) => {
        const currentYear = link.textContent.trim().slice(-4);
        link.href = `/pages/lookbook?option=${link.textContent.trim().toLowerCase()}`;
        if (index < links.length - 1) {
          const nextYear = links[index + 1].textContent.trim().slice(-4);
          if (currentYear !== nextYear) {
            link.classList.add("with-separation-in-navlinks");
            counterOfSeparation++;
          }
        }

        if(index == 3) {
          link.style.marginBottom = "22px";
        }

        if(index > 3) { // HC CHANGE IMPORTANT >=2, before counterOfSeparation
          link.style.display = "none";
        }
        counterOfSeparationNew++;
      });
    }
  }
});